/* global axios */
import ApiClient from './ApiClient';

class AutomationsAPI extends ApiClient {
  constructor() {
    super('automation_rules', { accountScoped: true });
  }

  clone(automationId) {
    return axios.post(`${this.url}/${automationId}/clone`);
  }

  /**
   * Dry run: does this rule match this conversation? Conditions only — no action runs, nothing
   * is written. `automationId` is optional so a rule being written for the first time can be
   * tested before it exists.
   */
  test({ automationId, conversationId, conditions, eventName }) {
    const url = automationId
      ? `${this.url}/${automationId}/test`
      : `${this.url}/test`;
    return axios.post(url, {
      conversation_id: conversationId,
      conditions,
      event_name: eventName,
    });
  }
}

export default new AutomationsAPI();
